import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import VideoLibraryOutlinedIcon from "@material-ui/icons/VideoLibraryOutlined";
import BusinessCenterOutlinedIcon from "@material-ui/icons/BusinessCenterOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import CardMembershipOutlinedIcon from "@material-ui/icons/CardMembershipOutlined";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ExploreOutlinedIcon from "@material-ui/icons/ExploreOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import {SITE_MODES} from "src/context/SiteMode";

export const CLIENT_MENU=[
  {label:"About",href:"/about",icon:InfoOutlinedIcon,description:"Who we are and how KUVUMA connects African creatives with the people who hire them."},
  {label:"Media Center",href:"/media-center",icon:VideoLibraryOutlinedIcon,description:"Browse and buy podcasts, video, audio and other media from KUVUMA creators."},
  {label:"Services",href:"/services",icon:BusinessCenterOutlinedIcon,description:"Creative services you can order, from production to distribution."},
  {label:"Find Creators",href:"/creators",icon:SearchOutlinedIcon,description:"Search the talent database by skill, location and experience, then shortlist and contact creatives."},
  {label:"Post an Opportunity",href:"/post-opportunity",guestHref:"/login",icon:AddCircleOutlineIcon,description:"Post a job, gig, audition or collaboration and let creatives apply with their portfolio."},
  {label:"Charges",href:"/charges",icon:ReceiptOutlinedIcon,description:"Service charges that apply to clients on KUVUMA."},
  {label:"Subscribe",href:"/subscription-plans",icon:CardMembershipOutlinedIcon,description:"Dashboard plans for clients, brands and organisations."},
  {label:"Team",href:"/team",icon:PeopleOutlineIcon,description:"Meet the people behind KUVUMA."},
  {label:"Contact Us",href:"/contact-us",icon:MailOutlineIcon,description:"Questions about hiring or pricing? Get in touch."},
];

export const CREATOR_MENU=[
  {label:"Opportunities",href:"/opportunities",icon:ExploreOutlinedIcon,description:"Jobs, gigs, auditions, grants and collaborations open to creatives."},
  {label:"My Applications",href:"/my-applications",guestHref:"/login",icon:AssignmentOutlinedIcon,description:"Track the opportunities you have applied to and their status."},
  {label:"Display Your Profile",href:"/display-your-profile",icon:AccountCircleOutlinedIcon,description:"See how complete your creator profile is and what is still missing."},
  {label:"Sell Your Media",href:"/add-media",guestHref:"/login",icon:CloudUploadOutlinedIcon,description:"Upload your work and sell it in the KUVUMA Media Center."},
  {label:"Charges",href:"/charges",icon:ReceiptOutlinedIcon,description:"Commission and fees that apply to creators on KUVUMA."},
  {label:"Subscribe",href:"/subscription-plans",icon:CardMembershipOutlinedIcon,description:"Plans and tools built for creators."},
  {label:"Contact Us",href:"/contact-us",icon:MailOutlineIcon,description:"Questions about getting started as a creator? Get in touch."},
];

export const getMenuForMode=(mode)=>mode===SITE_MODES.CREATOR?CREATOR_MENU:CLIENT_MENU;

export const getMenuHref=(item,userLoggedIn)=>!userLoggedIn&&item.guestHref?item.guestHref:item.href;

/** Location for menu navigation; guests on auth-required items get /login with return path. */
export const getMenuTo=(item,userLoggedIn)=>{
  if(!userLoggedIn&&item.guestHref){
    return {pathname:item.guestHref,state:{from:item.href}};
  }
  return item.href;
};
